import React, { ReactNode, useLayoutEffect, useRef, useState } from 'react';

import { useWindowDimensions } from '@/helpers/hooks';
import cn from '@/helpers/utils/classNames';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';

interface DropdownSubMenuProps {
  children: (props: { className?: string }) => ReactNode;
  label: string;
  className?: string;
}

const DropdownSubMenu = ({ children, label, className }: DropdownSubMenuProps) => {
  const [isActive, setIsActive] = useState(false);
  const dropdownRef = useRef<HTMLLIElement | null>(null);
  const { width } = useWindowDimensions();

  const handleMouseOver = () => {
    setIsActive(true);
  };

  const handleMouseOut = () => {
    setIsActive(false);
  };

  useLayoutEffect(() => {
    const content = dropdownRef?.current?.children[1] as HTMLElement;
    if (dropdownRef.current && content && document.body) {
      const { right: dropdownRight, width: dropdownWidth } = dropdownRef?.current?.getBoundingClientRect();
      const { right: bodyRight } = document.body.getBoundingClientRect();
      const { width: contentWidth } = content.getBoundingClientRect();
      const remainingSpace = bodyRight - dropdownRight;

      if (contentWidth > remainingSpace) {
        content.style.maxWidth = `${remainingSpace}px`;
      }
    }
  }, [isActive, width]);

  return (
    <li
      className={cn('v2-py-1', className)}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      ref={dropdownRef}
    >
      <div className="v2-flex v2-basis-full v2-items-center v2-justify-between v2-gap-3 v2-px-6 ">
        <span>{label}</span>
        {isActive ? <ExpandLessOutlined className="v2-text-xl" /> : <ExpandMoreOutlined className="v2-text-xl" />}
      </div>

      {isActive && (
        <>
          {children({
            className: '!v2-mt-0 v2-left-full v2-top-0',
          })}
        </>
      )}
    </li>
  );
};

export default DropdownSubMenu;
